// API Configuration
export const API_CONFIG = {
  // Custom domain (production)
  AWS_BASE_URL: 'https://api.novembr.dev',
  
  // Local development URL (fallback)
  LOCAL_BASE_URL: 'http://localhost:3001',
  
  // Use AWS API by default, but allow override via environment
  get BASE_URL() {
    // Check if we're in development mode and want to use local API
    const useLocal = process.env.REACT_APP_USE_LOCAL_API === 'true';
    return useLocal ? this.LOCAL_BASE_URL : this.AWS_BASE_URL;
  }
};

// API Endpoints
export const API_ENDPOINTS = {
  FACE_DETECT: '/api/face-detect',
  FACE_DETECT_BATCH: '/api/face-detect-batch',
  HEALTH: '/api/health',
  KEYS: '/api/keys',
} as const;

// Helper function to build full API URLs
export const buildApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};
